export default [
    {
        path: '/offers',
        name: 'offers-read',
        component: () => import('@/views/event/offers/OfferList.vue'),
        meta: {
        resource: 'Offers',
        action: 'read',
        },
    },
    {
        path: '/offers-icon',
        name: 'offers-icon-read',
        component: () => import('@/views/event/offers/OfferIconList.vue'),
        meta: {
            resource: 'Offer Icons',
            action: 'read',
        },
    },
]